import styled from "styled-components";
import theme from "../themes";

const sizes = {
  lg: {
    padding: '56px',
    fontSize: '20px',
    titleFontSize: '36px',
    titleMargin: '18px 0',
    iconSize: '48px',
  },
  sm: {
    padding: '24px',
    fontSize: '16px',
    titleFontSize: '24px',
    titleMargin: '12px 0',
    iconSize: '36px',
  },
}

export const ErrorContainer = styled('div', { 
  shouldForwardProp: (prop) => !['height', 'size'].includes(prop) 
})(({ height, size }) => `
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: ${height || '100vh'};
  padding: ${sizes[size].padding};
  font-size: ${sizes[size].fontSize};
`);

export const ErrorLogo = styled.img`
  width: auto;
  height: 56px;
`;

export const ErrorBody = styled('div', { 
  shouldForwardProp: (prop) => !['size'].includes(prop) 
})(({ size }) => `
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-size: ${sizes[size].fontSize};
  text-align: center;

  .fa-exclamation-triangle {
    font-size: ${sizes[size].iconSize};
    color: ${theme.dangerColor};
  }

  .btn-primary {
    min-width: 266px;
    margin-top: 16px;
    height: 42px;
  }

  h1 {
    font-size: ${sizes[size].titleFontSize};
    font-weight: 600;
    color: ${theme.primaryColor};
    margin: ${sizes[size].titleMargin};
  }
`);